import {XauditModel} from '../xaudit.model';

export class DoctorLicenseDataModel extends XauditModel {
  DoctorId: string;
  // TODO: spelling
  LicenceNumber: string;
  LicenceNumberID: string;
  enumLicenceStateID: string;
  TaxID: string;
  DEA: string;
  NPI: string;
  CustomParamsJSON: string;
}
